import React from 'react';
import {
  CardMedia,
  Card,
  CardTitle,
  Typography,
  Button
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import { useQuoteContext } from '../../../hooks/useQuoteContext';
import QuotesHeader from '../QuotesHeader';
import fallbackViewTexts from '../../../constants/fallbackViewTexts';
import { nullStatePropTypes } from './nullStatePropTypes';

const CompactNullView = ({
  imageAlt,
  imageUrl
}) => {
  const { componentId, isDashboardSnapshot } = useQuoteContext();

  const {
    cardTitle,
    bodyText,
    learnMoreText
  } = fallbackViewTexts;

  const { ref, clickID } = useImpression({
    data: {
      component: 'QuotesFallbackView',
      name: 'QuotesFallbackView',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  return (
    <Card
      data-component="Quotes"
      data-testid="compact-null-view"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          'sui-flex',
          'sui-flex-col',
          'sui-h-full',
          { 'sui-pt-4 sui-px-4 sui-pb-4': !isDashboardSnapshot },
          'sui-w-full'
        )
      }}
      // Dashboard Snapshot: no border or header row, like the desktop view, and no inset of its
      // own, since the snapshot's panel already insets its mobile content.
      PaperProps={isDashboardSnapshot ? { variant: 'shadow', shadow: 'none' } : undefined}
      ref={ref}
      clickid={clickID}
    >
      {!isDashboardSnapshot && <QuotesHeader hideActionLink />}
      <div className="sui-flex sui-flex-col sui-h-full">
        <div className={isDashboardSnapshot ? 'sui-rounded-md sui-overflow-hidden' : 'sui-mt-6'}>
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            aspect="wide"
          />
        </div>
        <div className="sui-mt-5">
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={<span style={{ whiteSpace: 'pre-line' }}>{cardTitle}</span>}
          />
        </div>
        <div className="sui-mt-1">
          <Typography>
            {bodyText}
          </Typography>
        </div>
        <div className="sui-mt-auto sui-pt-4">
          <Button
            variant="primary"
            fullWidth
            href="/c/create-a-quote"
          >
            {learnMoreText}
          </Button>
        </div>
      </div>
    </Card>
  );
};

CompactNullView.propTypes = nullStatePropTypes;

export default CompactNullView;
